export default {
  Router: Symbol.for('Router'),
  Route: Symbol.for('Route'),
  EventBus: Symbol.for('EventBus'),
  Store: Symbol.for('Store'),
  i18n: Symbol.for('i18n'),
  ACL: Symbol.for('$acl'),
  Cookies: Symbol.for('cookie'),
  RefreshCookies: Symbol.for('RefreshCookies'),
  RuntimeConfig: Symbol.for('RuntimeConfig'),
  Pinia: Symbol.for('Pinia'),
}
